var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('div',{staticClass:"relative z-index1 h-full w-full"},[_c('div',{},[_c('CoverPage'),_c('About'),_c('div',{},[_c('Contents')],1)],1)]),_c('div',{staticClass:"bge3ceff-opa rounded-t-5555"},[_c('DownloadApp'),_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }